(() => {
  if (window.__hubTocInit) return;
  window.__hubTocInit = true;

  document.querySelectorAll(".article-template__section__inner").forEach((section) => {
    const link = document.querySelector(`a[href="#${section.id}"]`);
    if (link) {
      link.addEventListener("click", () => {
        section.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
      });
    }
  });
})();
